/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import Grid from '../../../containers/dashboard/grid';
import Task from '../../../containers/task/shop';
import {getFormattedTasksColumns, getTaskColumnsAndTasks} from '../../../store/tasks/selectors';
import {displayshop, isQuality} from "../../../store/auth/selectors";
import {getworkstepcount} from "../../../store/tasks/actions";

class ShopGrid extends React.Component {


    componentDidMount() {

        const {getworkstepcount, displayshop} = this.props;
        getworkstepcount()

        if (!displayshop) {
            this.props.history.push('/dashboard/stock');
        }
    }

    render() {
        const {taskscolumns, isQuality} = this.props;
        const {tasks, columns} = taskscolumns;
        let allowedStatuses = [null, ''];
        if (isQuality){
            allowedStatuses = [null, 'reserved', '', 'done', 'in-progress', 'failed']
        }
        return (
            <Grid
                tasks={tasks}
                columns={columns}
                taskComponent={Task}
                // allowedStatuses={[null, 'reserved']}
                allowedStatuses={allowedStatuses}
            />
        );
    }
}

export default connect(
    state => ({
        // tasks: getTasksFormattedItems(state),
        // columns: getTaskColumns(state, getTasksFormattedItems),
        taskscolumns: getFormattedTasksColumns(state),
        isQuality: isQuality(state),
        displayshop: displayshop(state),
    }), {getworkstepcount}
)(ShopGrid);



// WEBPACK FOOTER //
// ./src/containers/dashboard/grid/shop.js